import { render, staticRenderFns } from "./ErrorNotificationModal.vue?vue&type=template&id=891f7fa2&scoped=true&"
import script from "./ErrorNotificationModal.vue?vue&type=script&lang=js&"
export * from "./ErrorNotificationModal.vue?vue&type=script&lang=js&"
import style0 from "./ErrorNotificationModal.vue?vue&type=style&index=0&id=891f7fa2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "891f7fa2",
  null
  
)

export default component.exports